module.exports = __webpack_public_path__ + "static/media/15.90e9ec57.jpeg";